export default {"src":"/_next/static/media/bank-visa-square.a58a90e6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};